/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PharmacyCounselorDelivery,
  PharmacyCounselorDeliveryFromJSON,
  PharmacyCounselorDeliveryToJSON,
  PharmacyCounselorDeliveryUpdatable,
  PharmacyCounselorDeliveryUpdatableFromJSON,
  PharmacyCounselorDeliveryUpdatableToJSON,
} from "../models";

export interface PatchCounselingsDeliveryRequest {
  counselingId: number;
  pharmacyCounselorDeliveryUpdatable: PharmacyCounselorDeliveryUpdatable;
}

/**
 *
 */
export class DeliveryApi extends runtime.BaseAPI {
  /**
   * Change delivery address information
   */
  async patchCounselingsDeliveryRaw(
    requestParameters: PatchCounselingsDeliveryRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyCounselorDelivery>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling patchCounselingsDelivery."
      );
    }

    if (
      requestParameters.pharmacyCounselorDeliveryUpdatable === null ||
      requestParameters.pharmacyCounselorDeliveryUpdatable === undefined
    ) {
      throw new runtime.RequiredError(
        "pharmacyCounselorDeliveryUpdatable",
        "Required parameter requestParameters.pharmacyCounselorDeliveryUpdatable was null or undefined when calling patchCounselingsDelivery."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/delivery`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PharmacyCounselorDeliveryUpdatableToJSON(requestParameters.pharmacyCounselorDeliveryUpdatable),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyCounselorDeliveryFromJSON(jsonValue));
  }

  /**
   * Change delivery address information
   */
  async patchCounselingsDelivery(
    requestParameters: PatchCounselingsDeliveryRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyCounselorDelivery> {
    return promiseRetry(
      (retry) =>
        this.patchCounselingsDeliveryRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
